var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.matched.length <= 1)?_c(_vm.MainComponent,{key:_vm.levelGetter.id,tag:"component"}):_c(_vm.ChildComponent,{key:_vm.levelGetter.id,tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }